module.exports = __webpack_public_path__ + "img/za.20874d39.svg";